import React, {Component, Fragment} from 'react'
import {Card, Col, Form, Icon, Input, Tooltip} from 'antd'
import TagSelect from '../../../../../elements/Select/Tag'

const FormItem = Form.Item

class EmailList extends Component {
  render() {
    const {
      list,
      handleChange,
      getFieldDecorator,
      formItemLayout,
      handleDefault,
      handleRemove,
      handleAdd,
    } = this.props
    return (
      <Card title="Email" type={'inner'} bordered={false} {...formItemLayout}>
        {list
          .filter(f => f.remove !== true)
          .map(e => (
            <Fragment>
              <Col span={8}>
                <FormItem {...formItemLayout}>
                  <TagSelect
                    onChange={handleChange.bind(this, 'email', e._key, 'tag')}
                    value={e.tag}
                  />
                </FormItem>
              </Col>
              <Col span={11}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('email' + e._key, {
                    initialValue: e.label,
                    rules: [
                      {
                        type: 'email',
                        required: true,
                        message: 'Email is Not Valid',
                      },
                    ],
                  })(
                    <Input
                      placeholder="Email"
                      onChange={handleChange.bind(
                        this,
                        'email',
                        e._key,
                        'label',
                      )}
                      value={e.label}
                    />,
                  )}
                </FormItem>
              </Col>
              <Col span={1}>
                <Tooltip title={'Set as Default'}>
                  <Icon
                    type={'star'}
                    theme={e.default && 'filled'}
                    style={{
                      fontSize: '13pt',
                      color: '#ceb21b',
                      cursor: 'pointer',
                    }}
                    onClick={
                      !e.default && handleDefault.bind(this, 'email', e._key)
                    }
                  />
                </Tooltip>
              </Col>
              <Col span={1}>
                <Icon
                  type={'minus-circle'}
                  onClick={handleRemove.bind(this, 'email', e._key)}
                  style={{fontSize: '13pt', cursor: 'pointer'}}
                />
              </Col>
            </Fragment>
          ))}

        <Col span={1}>
          <Icon
            type={'plus-circle'}
            onClick={handleAdd.bind(this, 'email')}
            style={{fontSize: '13pt', cursor: 'pointer'}}
          />
        </Col>
      </Card>
    )
  }
}

EmailList.propTypes = {}
EmailList.defaultProps = {}

export default EmailList
